export const GET_ENTITY_ALL_REQUEST = 'GET_ENTITY_ALL_REQUEST';
export const GET_ENTITY_ALL_SUCCESS = 'GET_ENTITY_ALL_SUCCESS';
export const GET_ENTITY_ALL_ERROR = 'GET_ENTITY_ALL_ERROR';
export const GET_ENTITY_LIST_REQUEST = 'GET_ENTITY_LIST_REQUEST';
export const GET_ENTITY_LIST_SUCCESS = 'GET_ENTITY_LIST_SUCCESS';
export const GET_ENTITY_LIST_ERROR = 'GET_ENTITY_LIST_ERROR';
export const ADD_ENTITY_REQUEST = 'ADD_ENTITY_REQUEST';
export const ADD_ENTITY_SUCCESS = 'ADD_ENTITY_SUCCESS';
export const ADD_ENTITY_ERROR = 'ADD_ENTITY_ERROR';
export const GET_ENTITY_REQUEST = 'GET_ENTITY_REQUEST';
export const GET_ENTITY_SUCCESS = 'GET_ENTITY_SUCCESS';
export const GET_ENTITY_ERROR = 'GET_ENTITY_ERROR';
export const UPDATE_ENTITY_REQUEST = 'UPDATE_ENTITY_REQUEST';
export const UPDATE_ENTITY_SUCCESS = 'UPDATE_ENTITY_SUCCESS';
export const UPDATE_ENTITY_ERROR = 'UPDATE_ENTITY_ERROR';
export const DELETE_ENTITY_REQUEST = 'DELETE_ENTITY_REQUEST';
export const DELETE_ENTITY_SUCCESS = 'DELETE_ENTITY_SUCCESS';
export const DELETE_ENTITY_ERROR = 'DELETE_ENTITY_ERROR';
export const UPDATE_ENTITY_LIST_OPTIONS = 'UPDATE_ENTITY_LIST_OPTIONS';
export const UPDATE_ENTITY_LIST_PAGINATION_OPTIONS =
  'UPDATE_ENTITY_LIST_PAGINATION_OPTIONS';
export const UPDATE_ENTITY_LIST_FILTER_OPTIONS =
  'UPDATE_ENTITY_LIST_FILTER_OPTIONS';
export const SELECT_ENTITY = 'SELECT_ENTITY';
export const DESELECT_ENTITY = 'DESELECT_ENTITY';
export const CANCEL_GET_ENTITIES = 'CANCEL_GET_ENTITIES';

export const PARTIAL_EXPORT_ENTITY_REQUEST = 'PARTIAL_EXPORT_ENTITY_REQUEST';
export const PARTIAL_EXPORT_ENTITY_COMPLETE = 'PARTIAL_EXPORT_ENTITY_COMPLETE';
export const PARTIAL_EXPORT_ENTITY_CANCEL = 'PARTIAL_EXPORT_ENTITY_CANCEL';

export const PARTIAL_IMPORT_ENTITY_REQUEST = 'PARTIAL_IMPORT_ENTITY_REQUEST';
export const PARTIAL_IMPORT_ENTITY_COMPLETE = 'PARTIAL_IMPORT_ENTITY_COMPLETE';
export const PARTIAL_IMPORT_ENTITY_CANCEL = 'PARTIAL_IMPORT_ENTITY_CANCEL';

export const IMPORT_AND_MERGE_REQUEST = 'IMPORT_AND_MERGE_ENTITY_REQUEST';
export const IMPORT_AND_MERGE_COMPLETE = 'IMPORT_AND_MERGE_ENTITY_COMPLETE';
export const IMPORT_AND_MERGE_CANCEL = 'IMPORT_AND_MERGE_ENTITY_CANCEL';
